import React from "react";
import { Navigate } from "react-router-dom";
import useFeatureFlags from "../hooks/useFeatureFlags";

export default function FlagRoute({ flag, children }) {
  const { flags, loading } = useFeatureFlags();

  if (loading) return null;
  if (!flags[flag]) return <Navigate to="/" replace />;

  return children;
}
